$(function(){
  // $.removeCookie('section_cookie');
  if($.cookie('section_cookie') != 'set'){
    setTimeout(function(){
      $('.section-cookie__close').parent().slideDown();
    }, 1500);
  }
  if($.cookie('section_cookie') == 'disagree'){
    setInterval(function() {
        $.each($.cookie(), function(key, value) {
            $.removeCookie(key);
        });
        console.log("All cookies deleted");
    }, 5000);
}



  $('body').on('click', '#js_agree_cookies', function(){
    $(this).parent().parent().slideUp();
    $.cookie('section_cookie', 'set');
  });

  $('body').on('click', '#js_disagree_cookies', function(){
    console.log('js_disagree_cookies')
    $.cookie('section_cookie', 'disagree');
  });

});
